import React from "react";
import { useEmployeeContribution } from "../hooks/useEmployeeContribution";
import { WizardStepSkeleton } from "../../WizardStepSkeleton";
import { WizardStepError } from "../../WizardStepError";
import ContributionActions from "../components/ContributionActions";
import EmployeeContributionForm from "../components/EmployeeContributionForm";

interface EmployeeContributionStepProps {
  isUserEnrolled?: boolean;
  onPrevious: () => void;
}

const EmployeeContributionStep: React.FC<EmployeeContributionStepProps> = ({
  isUserEnrolled,
  onPrevious,
}) => {
  const {
    loading,
    isSubmitting,
    error,
    employeeContribution,
    employerContribution,
    employeeInformation,
    benefitContributionLimit,
    calculations,
    handleContributionChange,
    handleSubmitContribution,
  } = useEmployeeContribution(isUserEnrolled);

  const handleNext = async () => {
    await handleSubmitContribution();
  };

  if (loading) return <WizardStepSkeleton />;

  if (error) {
    return (
      <WizardStepError
        step={3}
        handlePrevious={onPrevious}
        errorMessage={error}
      />
    );
  }

  return (
    <>
      <EmployeeContributionForm
        employeeContribution={employeeContribution}
        employerContribution={employerContribution}
        employeeInformation={employeeInformation}
        benefitContributionLimit={benefitContributionLimit}
        calculations={calculations}
        onContributionChange={handleContributionChange}
      />

      <ContributionActions
        isUserEnrolled={isUserEnrolled}
        isSubmitting={isSubmitting}
        currentStep={1}
        onPrevious={onPrevious}
        onNext={handleNext}
      />
    </>
  );
};

export default EmployeeContributionStep;
